import React from 'react'
import Navbar from '../header/Navbar'
import Footer from '../footer/Footer'
import TicTacToe from '../games/tictactoe/TicTacToe'

const Entertainment = () => {
  return (
    <div>
      <Navbar/>
      <TicTacToe/>
      <Footer/>
    </div>
  )
}

export default Entertainment